/**
 * Generate a URL-safe ID from a heading string (supports Chinese characters).
 */
export const generateHeadingId = (text: string): string =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\u4e00-\u9fa5-]/g, '');

export interface TocItem {
  id: string;
  text: string;
  level: 2 | 3;
}

/**
 * Parse ## and ### headings from markdown-like blog content.
 */
export const extractToc = (content: string): TocItem[] =>
  content
    .split('\n')
    .filter((line) => line.startsWith('## ') || line.startsWith('### '))
    .map((line) => {
      const level = line.startsWith('### ') ? 3 : 2;
      const text = line.replace(/^#{2,3} /, '');
      return { id: generateHeadingId(text), text, level };
    });
